import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from '../exg-modal.service';

@Component({
  selector: 'exg-modal-simple',
  templateUrl: './exg-modal-simple.component.html',
  styles: []
})
export class ExgModalSimpleComponent implements OnInit {
  @Input() data!: {
    [key: string]: any | undefined,
    title: string,
    message: string,
    btnOk: boolean,
    btnCancel: boolean,
    btnOkCaption: string,
    btnCancelCaption: string
  };

  constructor(private popUpService: ExgModalService) {
  }

  ngOnInit(): void {
  }

  clickedOK(): void {
    this.popUpService.action(true);
  }

  clickedCancel(): void {
    this.popUpService.action(false);
  }

}
